export default __webpack_public_path__ + "static/summer_containers84-60881eb6d5d97538d09c0c57de51a967.webp";